import React, { useState, useEffect } from 'react';
import NavMenu from 'components/NavMenu';
import { useStyles, styles } from './ListadoKeyUserScreenStyles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Link from '@material-ui/core/Link';
import TextEvents from 'app/components/TextEvents';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import { useDispatch, useSelector } from 'react-redux';
import * as ListadoKeyUserActions from '../../actions/ListadoKeyUserActions'
import FilterScreen from './FilterComponent/FilterComponent';
import TableScreen from './TableComponent/TableComponent';
import { Modal, Button, Spin, Table, Form, Select } from 'antd';
import { Grid } from '@material-ui/core';
import { employeeById } from 'app/reducers';
import TextInput from '../../../app/components/TextInput';
import { debounce } from 'debounce';
import ApiService from 'app/services/ApiService';

const ListadoKeyUserScreen = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { siteId } = useSelector(state => state.Auth)
    const employeeData = useSelector(employeeById);

    const {
        isLoadingFilters,
        pagination,
        filter,
        isLoadingAllKeyUser,
        listAllKeyUser,
    } = useSelector(state => state.ListadoKeyUserReducer);

    useEffect(() => {
        dispatch(ListadoKeyUserActions.getFiltersKeyUsers());
        dispatch(ListadoKeyUserActions.getKeyUsers());
    }, [dispatch]);

    const [height, setHeight] = useState(window.innerHeight);
    window.addEventListener('resize', () => {
        setHeight(window.innerHeight);
    });

    return (
        <div className={classes.root}>
            <NavMenu SelectedIndex={props.history.location.pathname} isRepor={true} header='Listado de Key Users' isCommunicationStatus={false} />
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.appBarSpacer} />
                <div elevation={0} style={styles.titleBox}>
                    <Breadcrumbs aria-label='Breadcrumb'>
                        <Link color='inherit' disabled>
                            Reportes
                        </Link>
                        <TextEvents
                            text={'Listado de Key Users'}
                            color='cotemar'
                            size='subtitle'
                            weight='bold'
                        />
                    </Breadcrumbs>
                    <Paper className={classes.rootPaper}>
                        <FilterScreen></FilterScreen>
                        <TableScreen  dtsize={{ x: 'min-content', y: (height - 430) }}></TableScreen>
                    </Paper>
                </div>
            </div>
        </div>
    )
}

export default ListadoKeyUserScreen;
